export default "__VITE_ASSET__f8ec4ee9__"